import "reflect-metadata";
import "regenerator-runtime/runtime";
import "./tailwind.css";

import * as React from "react";

import { SENTRY_ENABLED } from "@daytrip/legacy-config";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import { initializeApolloClient } from "./apolloClient/apolloClient";
import App from "./App";
import {
    ENVIRONMENT,
    MANAGEMENT_SENTRY_DSN,
    MANAGEMENT_TRACES_SENTRY_SAMPLE_RATE,
    REACT_ROOT_ELEMENT_ID,
} from "./config.management";
import { container } from "./container";
import "./utils/analytics/amplitudeInstances";

initializeApolloClient();

const integrations = [Sentry.browserTracingIntegration()];

// if (IS_PRODUCTION) {
//     integrations.push(new Sentry.Replay());
// }

if (SENTRY_ENABLED) {
    Sentry.init({
        dsn: MANAGEMENT_SENTRY_DSN,
        integrations,
        ignoreErrors: [
            // Random network errors
            "Failed to fetch",
            "Load failed",
            "Fetch is aborted",
            "Missing authentication token",
            "Validation error",
        ],
        tracesSampleRate: MANAGEMENT_TRACES_SENTRY_SAMPLE_RATE,
        environment: ENVIRONMENT,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
    });
}

const rootElement = document.getElementById(REACT_ROOT_ELEMENT_ID);

if (!rootElement) {
    throw new Error(`Root element with id ${REACT_ROOT_ELEMENT_ID} not found`);
}

createRoot(rootElement).render(<App container={container} />);
